export default __webpack_public_path__ + "bcc1376a4fd653056039b1ea32a9730e.svg";